const CHECK_AND_VERIFY_PHONE = `${process.env.API_V4_HOST}/_exclusive/mitra/info/check-phone-number`;

export const postCheckAndVerifyPhone = ($axios, payload) => {
  const { old_phone: oldPhone, new_phone: newPhone, otpCode, skipOtp, otpMethod } = payload;
  const headerOtpMethod = otpMethod || 'sms';
  const request = {
    headers: {},
  };

  if (!skipOtp) {
    request.headers['bukalapak-otp-method'] = headerOtpMethod;
  }

  if (otpCode) {
    request.headers['bukalapak-phone-token'] = otpCode;
  }
  return $axios.$post(CHECK_AND_VERIFY_PHONE, { old_phone: oldPhone, new_phone: newPhone }, { ...request });
};
